import { NgModule, Injectable } from '@angular/core';
import { Routes, RouterModule, CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { IntroductionComponent } from './components/introduction/introduction.component';
import { UserDataComponent } from './components/user-data/user-data.component';
import { FinalizationComponent } from './components/finalization/finalization.component';
import { CompletedComponent } from './components/completed/completed.component';
import { PollManagerComponent } from './components/poll-manager/poll-manager.component';
import { Observable } from 'rxjs';
import { RoutesManagerService } from './services/routes-manager.service';


@Injectable()
export class RouteGuard implements CanActivate {
  constructor(private router: Router, private routesManager: RoutesManagerService) { }

  canActivate(next: ActivatedRouteSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    const currentValue = this.routesManager.getCurrentRouteValue();
    return this.isNextValueEqualsCurrentValue(next, currentValue) || this.isIntroduction(currentValue);
  }

  private isNextValueEqualsCurrentValue(next, currentValue) {
    return this.routesManager.getValueFor(next.url[0].path) === currentValue;
  }
  private isIntroduction(currentValue) {
    return currentValue === 'introduccion' && this.router.url !== '/introduccion';
  }
}


const routes: Routes = [
  { path: 'introduccion', canActivate: [RouteGuard], component: IntroductionComponent },
  { path: 'datos', canActivate: [RouteGuard], component: UserDataComponent },
  { path: 'finalizacion', canActivate: [RouteGuard], component: FinalizationComponent },
  { path: 'completada', canActivate: [RouteGuard], component: CompletedComponent },
  { path: 'encuesta', canActivate: [RouteGuard], component: PollManagerComponent },
  { path: '**', pathMatch: 'full', redirectTo: 'introduccion' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
